const TOGGLE_CLASS = 'text-[11px] text-[#376fd0] hover:underline';

export default function FinancialCompositionToggle({ isDetailed, onToggle }) {
    return (
        <button type="button" onClick={onToggle} aria-expanded={isDetailed} className={TOGGLE_CLASS}>
            {isDetailed ? 'Ocultar composição' : 'Ver composição'}
        </button>
    );
}
